import { Button, ButtonProps, styled } from "@mui/material";

const RoundedGreenButton = styled(Button)<ButtonProps>(() => ({
  backgroundColor: "#79be21",
  borderRadius: "20px",
  padding: "8px 12px",
}));

export default RoundedGreenButton;